import React, { Component } from 'react'
import DashboardPage from './DashboardPage'
import './../styles/_index.scss'
import SkuNotBatches from "./sku-not-batches/SkuNotBatches"
import BatchProductionStatusPage from './BatchProductionStatusPage'
import GarmentQuantityStatisticsPage from './GarmentQuantityStatisticsPage'
import QCHTQuantityStatisticsPage from './QCHTQuantityStatisticsPage'
import PackagedQuantityStatisticsPage from './PackagedQuantityStatisticsPage'
import ProductionStatisticsBySewingPartnerPage from './ProductionStatisticsBySewingPartnerPage'
import EmbroideryProductionPage from './embroidery-production/EmbroideryProductionPage'
import store from 'store'
import { getUrlParam, setUrlParam } from './dashboardUrlState'
import { Icon, Select } from "antd"

class DashboardContainer extends Component {

    state = {
        activeTab: '',
        statisticsType: 'Sewed'
    }

    componentDidMount() {
        const VALID_TABS = ['overtime', 'produce', 'BatchProductionStatus', 'GarmentQuantityStatistics', 'ProductionStatisticsBySewingPartner', 'EmbroideryProduction']
        // Ưu tiên ?tab= trên địa chỉ (link gửi theo tab) → tab đã nhớ → mặc định
        const urlTab = getUrlParam('tab')
        const activeTab = VALID_TABS.includes(urlTab) ? urlTab : store.get('3d_dashboard')
        const nextTab = VALID_TABS.includes(activeTab) ? activeTab : 'overtime'
        this.setState({activeTab: nextTab}, () => setUrlParam('tab', nextTab))
    }

    _onChangeTabActive = (active) => {
        this.setState({
            activeTab: active,
            statisticsType: 'Sewed',
        }, () => {
            store.set('3d_dashboard', this.state.activeTab)
            setUrlParam('tab', this.state.activeTab)
        })
    }

    _getActiveTab = () => {
        const { activeTab, statisticsType } = this.state
        if (activeTab === 'overtime') { return <DashboardPage /> }
        if (activeTab === 'BatchProductionStatus') { return <BatchProductionStatusPage /> }
        if (activeTab === 'produce') { return <SkuNotBatches /> }
        if (activeTab === 'GarmentQuantityStatistics') {
            if (statisticsType === 'Sewed') {
                return <GarmentQuantityStatisticsPage />
            }
            if (statisticsType === 'QCHT') {
                return <QCHTQuantityStatisticsPage />
            }
            if (statisticsType === 'Packaged') {
                return <PackagedQuantityStatisticsPage />
            }
        }
        if (activeTab === 'ProductionStatisticsBySewingPartner') {
            return <ProductionStatisticsBySewingPartnerPage />
        }
        if (activeTab === 'EmbroideryProduction') {
            return <EmbroideryProductionPage />
        }
    }

    _onChangeSelect = (value) => {
        this.setState({
            statisticsType: value
        })
    }

    render() {
        const { activeTab, statisticsType } = this.state

        if (activeTab === '') return null
        const { Option } = Select

        return (
            <div className="DashboardContainer">
                <div className='TabHead p-3 m-3 d-flex justify-content-between'>
                    <ul className='TabFilter'>
                        <li
                            className={`${activeTab === 'overtime' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('overtime')}
                        >
                            <Icon type="bar-chart" className='mr-1' />
                            Thống kê tiến độ sản xuất
                        </li>
                        <li
                            className={`${activeTab === 'produce' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('produce')}
                        >
                            <Icon type="area-chart" className='mr-1' />
                            Chưa phân lô
                        </li>
                        <li
                            className={`${activeTab === 'BatchProductionStatus' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('BatchProductionStatus')}
                        >
                            <Icon type="table" className='mr-1' />
                            Trạng thái sản xuất theo lô
                        </li>
                        <li
                            className={`${activeTab === 'GarmentQuantityStatistics' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('GarmentQuantityStatistics')}
                        >
                            <Icon type="table" className='mr-1' />
                            Thống kê sản lượng
                        </li>
                        <li
                            className={`${activeTab === 'ProductionStatisticsBySewingPartner' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('ProductionStatisticsBySewingPartner')}
                        >
                            <Icon type="table" className='mr-1' />
                            Thống kê sản xuất theo partner may
                        </li>
                        <li
                            className={`${activeTab === 'EmbroideryProduction' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('EmbroideryProduction')}
                        >
                            <Icon type="scissor" className='mr-1' />
                            Sản xuất thêu
                        </li>
                    </ul>
                    {activeTab === 'GarmentQuantityStatistics' &&
                        <div className='selectDiv'>
                            <Select
                                style={{ minWidth: '200px' }}
                                defaultValue={statisticsType}
                                onChange={this._onChangeSelect}
                            >
                                <Option value={'Sewed'}>Sản lượng may</Option>
                                <Option value={'QCHT'}>Sản lượng QC hoàn thành</Option>
                                <Option value={'Packaged'}>Sản lượng đóng gói</Option>
                            </Select>
                        </div>
                    }
                </div>

                <div className='tabContent'>
                    {
                        this._getActiveTab()
                    }
                </div>
            </div>
        )
    }

}

export default DashboardContainer
